/* Kart videolari: fare kartin uzerine gelince oynar, ayrilinca durur ve
   basa doner. preload="none" oldugu icin video ancak gerektiginde inar;
   boylece koleksiyon sayfasi 30 video yuzunden agirlasmaz. */

(function () {
  const bind = (video) => {
    if (video.dataset.cvReady === 'true') return;
    const card = video.closest('.product--card-inner') || video.parentElement;
    if (!card) return;
    video.dataset.cvReady = 'true';

    card.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      // Sessiz oynatma tarayicilar tarafindan engellenmez
      video.muted = true;
      const played = video.play();
      if (played && played.catch) played.catch(() => {});
    });

    card.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      video.pause();
      video.currentTime = 0;
    });
  };

  const init = () => document.querySelectorAll('[data-card-video]').forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
